export const authStrings = {
  useAuthProviderError: 'useAuth は <AuthProvider> 内で使用する必要があります',
  signIn: 'ログイン',
  signOut: 'ログアウト',
  signingOut: 'ログアウト中...',
  checkingSessionBody: 'セッションを確認中です...',
  emailLabel: 'メールアドレス',
  emailPlaceholder: 'you@example.com',
  passwordLabel: 'パスワード',
  passwordPlaceholder: 'パスワードを入力してください',
  working: '処理中...',
  signOutFailed: 'ログアウトに失敗しました。',
  accountPaused: 'このアカウントは停止されています。管理者にお問い合わせください。',
} as const;

export const organizationStrings = {
  loadFailed: '組織情報を読み込めませんでした。',
  selectTitle: '組織を選択',
  selectDescription: 'アクセスする組織を選択してください。',
  notAvailable: 'この組織にはアクセスできません。組織を選択し直してください。',
  noMemberships: 'アクセスできる組織がありません。管理者にお問い合わせください。',
  entryFailed: '画面を表示できませんでした。',
  selectAction: 'この組織で開く',
  lastSelected: '前回選択',
  unreadLabel: (count: number) => `未読 ${count} 件`,
  unreadNone: '未読なし',
  switcher: {
    label: '組織を切り替える',
    currentLabel: '現在の組織',
    switchToLabel: (organizationName: string) =>
      `${organizationName} に切り替える`,
    busy: '送信中の処理が完了するまで、組織を切り替えできません。',
    unsavedTitle: '未保存の入力があります',
    unsavedMessage:
      '組織を切り替えると、入力中の内容は失われます。破棄して切り替えますか？',
    unsavedConfirm: '破棄して切り替える',
    unsavedCancel: 'キャンセル',
    switchFailed: '組織を切り替えできませんでした。',
  },
} as const;

export const commonStrings = {
  somethingWentWrong: '何か問題が発生しました。',
  receivedMessage: 'メッセージが届きました！',
  noData: 'データなし。',
  search: '検索',
  draft: 'ドラフト: ',
  honorificSuffix: 'さん',
  success: '成功しました',
  cancel: 'キャンセル',
  close: '閉じる',
  send: '送信',
  required: '必須',
  actions: {
    backToList: '一覧へ戻る',
    retry: '再試行',
    save: '保存',
    update: '更新',
    updateSuccess: '更新しました',
    edit: '編集',
    show: '表示',
    hide: '非表示',
    copy: 'コピー',
    copySuccess: 'コピーしました',
    delete: '削除',
    seeMore: 'もっと見る',
    seeLess: '閉じる',
    emoji: '絵文字',
  },
  loadingEllipsis: '...',
  loading: '読み込み中...',
  countSuffix: '件',
  filteredEmpty: '該当データがありません',
  filters: {
    all: 'すべて',
    searchLabel: '検索',
    resultLabel: '検索結果',
    clearSearch: '検索キーワードをクリア',
    clearFilterSuffix: 'フィルターをクリア',
    fromSuffix: '開始日',
    toSuffix: '終了日',
    toggleLabel: '検索・絞り込み',
  },
  pagination: {
    previous: '前へ',
    next: '次へ',
    page: 'ページ',
    empty: '0 / 0',
  },
} as const;

export const iosInstallStrings = {
  title: 'ホーム画面に追加',
  description:
    'Safari下部の共有ボタンから「ホーム画面に追加」を選ぶと、アプリのように起動でき、通知も受け取れます。',
  shareStep: '共有ボタンをタップ',
  addStep: '「ホーム画面に追加」を選択',
  dismissLabel: '閉じる',
} as const;

export const webPushStrings = {
  enableTitle: '通知を有効にする',
  enableDescription: '新しいメッセージが届いたときに通知を受け取れます。',
  enableButton: '通知を有効化',
  enabling: '設定中...',
  enableError:
    '通知の設定に失敗しました。通信環境をご確認のうえ、もう一度お試しください。',
  retryButton: '再試行',
  dismissLabel: '閉じる',
} as const;

export const headerStrings = {
  appTour: 'アプリツアー',
  appTourLabel: 'アプリツアー（新しいタブで開く）',
  copyEntryUrl: '友達追加URLをコピー',
  copyEntryUrlSuccess: 'コピーしました',
  copyEntryUrlError: 'コピーに失敗しました',
} as const;

export const sidebarStrings = {
  menuLabel: 'メニュー',
  settingsGroupLabel: '設定',
  mobileNavOpenLabel: 'メニューを開く',
  mobileNavCloseLabel: 'メニューを閉じる',
  navLabels: {
    adCode: '広告コード',
    notice: 'お知らせ',
    line: 'LINE管理',
    banStatus: 'アカウントBAN状況',
    users: 'ユーザー管理',
    tag: 'タグ管理',
    organizationManagement: '組織管理',
    accountManagement: 'アカウント管理',
    chat: 'チャット管理',
    inquiryChat: 'お問い合わせチャット',
    aiKnowledge: 'よくある質問管理',
    sendMessageForAll: '一斉送信',
    messageSettings: 'メッセージ設定',
    autoReplyMessage: '自動応答メッセージ',
    richMessage: 'リッチメッセージ',
    cardTypeMessage: 'カードタイプメッセージ',
    chatMale: 'チャット',
    summaryManagement: '送信履歴',
    friendAnalytics: '友だち分析',
    richMenu: 'リッチメニュー',
    oaCreation: '公式LINE作成',
    termsManagement: '利用規約管理',
  },
} as const;

export const dashboardStrings = {
  noticeTitle: 'お知らせ',
} as const;

export const summaryManagementStrings = {
  title: '集計管理',
  description: '計測対象URLを含むLINE送信の結果を表示します。',
  archive: {
    open: '過去の開封集計',
    back: 'クリック集計に戻る',
    description:
      '旧方式で記録した一斉送信の開封数です。現在のクリック数とは定義が異なります。',
  },
  search: {
    deliveryYearLabel: '配信年',
    yearSuffix: '年',
    sourceTypeLabel: '送信種別',
    searchButton: '検索',
    reloadButton: '再読み込み',
    clickSearchHint: '配信を開始した年と送信種別で検索できます。',
    legacyOpenSearchHint: '過去の一斉送信を配信年で検索できます。',
  },
  sourceTypes: {
    BULK: '一斉送信',
    CHAT_NOTIFICATION: '個別チャット通知（LINE）',
    GREETING: 'あいさつメッセージ',
    AUTO_REPLY: '自動応答',
    TEST: 'テスト配信',
  },
  coverageWarnings: {
    PARTIAL: '一部URLは未計測',
    NONE: '全URL未計測',
  },
  coverageHints: {
    PARTIAL:
      '一部のURL箇所は計測できていません。表示中のクリック数は取得できたクリックだけを集計しています。',
    NONE: 'すべてのURLを計測できなかったため、クリック数は表示できません。',
  },
  deliveryStatus: {
    RUNNING: '送信中',
    COMPLETED: '完了',
    PARTIALLY_FAILED: '一部失敗',
    UNKNOWN: '結果不明',
    FAILED: '失敗',
  },
  deliveryStatusHints: {
    RUNNING: '送信処理を実行しています。',
    COMPLETED: '送信処理が完了しました。',
    PARTIALLY_FAILED: '一部の送信に失敗しました。',
    UNKNOWN: '外部サービスへの送信結果を確定できませんでした。',
    FAILED: '送信に失敗しました。',
  },
  recipientBadges: {
    unavailable: '送信不可 $count人',
    unknown: '結果不明 $count人',
    // 送信人数に含まれる利用者だけが未確定のとき、人数は重複計上しないので注記だけ出す。
    unknownPartial: '一部メッセージの結果を確認できません',
  },
  table: {
    startedAt: '送信日時',
    startedAtHint: '実際に配信処理を開始した日時',
    sourceType: '送信種別',
    sourceTypeHint: 'メッセージを送信した機能を表示',
    status: '送信状態',
    statusHint: '論理送信操作全体の状態',
    sentRecipientCount: '送信人数',
    sentRecipientCountHint:
      '計測対象URLを含むメッセージをLINEが受理したユニーク受信者数',
    totalClicks: '総クリック数',
    totalClicksHint: 'bot・プレビューを除く有効クリックの延べ回数',
    uniqueClickRecipientCount: 'ユニーク',
    uniqueClickRecipientCountHint:
      '1回以上クリックした人数。同じ人が何度押しても1人と数えます',
    clickRate: 'クリック率',
    clickRateHint: 'ユニーク ÷ 送信人数',
    legacyDeliveryCount: '配信数',
    legacyDeliveryCountHint: '旧方式で送信成功として記録された一斉送信の件数',
    legacyOpenedCount: '旧開封数',
    legacyOpenedCountHint:
      '旧record-open方式で記録された値。現在のクリック数とは比較できません。',
    legacyOpenedRate: '旧開封率',
    legacyOpenedRateHint: '旧開封数 ÷ 配信数',
    detail: '詳細',
    detailHint: 'URL別クリック数を確認',
    contentConfirm: '内容確認',
    contentConfirmHint: '送信時に保存した内容を確認',
  },
  detail: {
    title: 'クリック詳細',
    emptyHint: '行の「詳細」を選択するとURL別クリック数を確認できます。',
    loading: '詳細を読み込んでいます。',
    linksTitle: 'URL別クリック数',
    noLinks: '表示できるURLはありません。',
    displayUrl: '遷移先URL',
    totalClicks: 'クリック数',
    uniqueClickRecipientCount: 'ユニーク',
    clickRate: 'クリック率',
    openClickedUsers: 'クリックしたユーザーを見る（$count人）',
    unsupportedNotice:
      'この配信は人単位の計測対象外です（対応前に送信されたため、誰がクリックしたかは記録されていません）。',
  },
  clickedUsers: {
    title: 'クリックしたユーザー',
    countLabel: '$count人',
    loading: 'ユーザーを読み込んでいます。',
    empty: 'クリックしたユーザーはまだいません。',
    close: '閉じる',
    columns: {
      name: '名前',
      links: '押したURL',
      totalClicks: '合計',
      lastClickedAt: '最終クリック',
    },
    unknownUser: '不明なユーザー',
    unknownUserHint:
      '送信後にLINE連携が変わったため、現在の利用者を特定できません。',
    linkClickCount: '$count回',
    openChat: 'チャットを開く',
    friendStatus: {
      NORMAL: '通常',
      BLOCKED: 'ブロック',
      NO_LINKED_CHANNEL: 'LINE連携なし',
    },
  },
  unavailableMetric: '—',
  refreshing: '更新中',
  resultHint: '検索結果の表示',
  emptyResults: {
    CLICK: '検索条件に該当する、計測対象URLを含む送信はありません。',
    LEGACY_OPEN: '検索条件に該当する、過去の一斉送信はありません。',
  },
  paginationPage: 'ページ',
  errors: {
    loadFailed: '集計データの取得に失敗しました。',
    detailLoadFailed: 'クリック詳細の取得に失敗しました。',
    clickedUsersLoadFailed: 'クリックしたユーザーの取得に失敗しました。',
  },
} as const;

export const sendHistoryStrings = {
  title: '送信履歴',
  description: '送信した内容と結果を、リンクの有無にかかわらず確認できます。',
  content: '送信内容',
  detailTitle: '送信の詳細',
  detailLoadFailed:
    '送信の詳細を取得できませんでした。再読み込みしてください。',
  contentTab: '送信内容',
  clicksTab: 'クリック集計',
  noTrackingUrl: '計測対象URLなし',
  empty: '検索条件に該当する送信履歴はありません。',
  unavailable: '確認できません',
  filterHint:
    'あいさつメッセージとテスト配信は、送信種別を選ぶと表示されます。',
  snapshotHint: '送信時点の内容です。プレビューのリンクからは移動できません。',
  sentHint:
    'LINEがメッセージを1件以上受理した人数です。到達や既読を示すものではありません。',
  clickEligibleRecipients: 'クリック計測の対象人数',
  clickRateHint:
    'クリック率は、計測対象URLを含むメッセージをLINEが受理した人数を分母にしています。',
  recipientTrackingUnavailable:
    'この送信は人単位のクリック計測に対応していません。',
  backToHistory: '送信履歴へ戻る',
} as const;

export const userStrings = {
  title: 'ユーザー一覧',
  countDescription:
    '同じユーザーを1人として数えています。総数にはブロック済み・停止アカウントのユーザーや、チャット参加のみのユーザーも含みます。友だち分析のLINE集計（アカウントごとの延べ数）とは異なります。',
  pagination: {
    previous: '前へ',
    next: '次へ',
    page: 'ページ',
    empty: '0 / 0',
  },
  table: {
    headers: {
      actions: '操作',
      id: 'ID',
      lineName: 'LINE名',
      linkedBasicId: '紐づいているLINEアカウントのベーシックID',
      friendStatus: '友達状態',
      tag: 'タグ',
      isTestUser: 'テストユーザー',
      lastAccessAt: '最終アクセス',
      friendRegisteredAt: '友達登録日時',
    },
    friendStatus: {
      normal: '通常',
      blocked: 'ブロック',
      noLinkedChannel: 'LINE連携なし',
    },
    noLinkedBasicId: 'LINE連携なし',
    emptyValue: '-',
  },
  states: {
    empty: 'LINE友だちがいません。',
  },
  filters: {
    searchPlaceholder: 'ID / LINE名 / ベーシックIDで検索',
    friendStatus: '友だち状態',
    tag: 'タグ',
    lastAccessAt: '最終アクセス',
    friendRegisteredAt: '友だち登録日時',
    testUser: 'テストユーザー',
    testUserOnly: 'テストユーザーのみ',
    untagged: 'タグなし',
    adCode: '流入元',
    adCodeNone: '流入元なし（自然流入）',
    adCodeSearch: '広告コードを検索',
    adCodeOnly: 'のみ',
    adCodeExcept: '以外',
    adCodeSelected: '件を選択',
  },
  errors: {
    loadFriendsFailed: 'LINE友だち一覧の取得に失敗しました。',
    updateTestUserFailed: 'テストユーザー設定の更新に失敗しました。',
  },
  edit: {
    kicker: 'line friend edit',
    title: 'ユーザー編集',
    description: 'ユーザーのLINE名とメモを更新します。',
    summary: {
      title: '基本情報',
      emptyValue: '-',
      labels: {
        id: 'ID',
        originalLineName: '元のLINE名',
        linkedBasicId: '紐づきベーシックID',
        friendStatus: '友だち状態',
        lastAccessAt: '最終アクセス',
        friendRegisteredAt: '友だち登録日時',
      },
    },
    form: {
      title: '編集内容',
      description: '更新したい項目を修正してください。',
      fields: {
        lineName: {
          label: 'LINE名',
          placeholder: '例: 山田太郎',
        },
        memo: {
          label: 'メモ',
          placeholder: 'ユーザーに関するメモを入力',
          helper: '最大1000文字',
        },
        isTestUser: {
          label: 'テストユーザー',
          helper: 'ONにすると一斉送信のテスト配信の対象になります。',
        },
      },
    },
    states: {
      notFound: '対象のユーザーが見つかりません。',
    },
    errors: {
      loadFailed: 'ユーザー情報の取得に失敗しました。',
      required: 'LINE名は必須です。',
      unauthorized: '認証情報が取得できませんでした。再ログインしてください。',
      updateFailed: 'ユーザー情報の更新に失敗しました。',
    },
  },
} as const;

export const organizationFeatureStrings = {
  labels: {
    tagManagement: 'タグ管理',
    bulkSendTagging: '一斉配信でタグつけ',
    survey: 'アンケート',
    stepDelivery: 'ステップ配信',
  },
  unavailable:
    '$featureは現在ご利用いただけません。利用をご希望の場合は管理者にお問い合わせください。',
} as const;

export const organizationManagementStrings = {
  title: '組織一覧',
  actions: {
    createOrganization: '組織登録',
  },
  messages: {
    createSuccess: '組織を登録しました。',
    updateSuccess: '組織を更新しました。',
  },
  table: {
    headers: {
      actions: '操作',
      id: 'ID',
      entryKey: 'エントリーキー',
      name: '組織名',
      plan: 'プラン設定',
      createdAt: '登録日時',
    },
  },
  planLabels: {
    LIGHT: 'ライトプラン',
    BASIC: 'ベーシックプラン',
    INTERNAL: '自社利用',
  },
  features: {
    label: '利用機能',
    note: 'チェックした機能だけがこの組織の管理画面で使えます。OFFにしてもデータは削除されません。',
    preparing: '準備中',
  },
  states: {
    empty: '組織がありません。',
    notFound: '対象の組織が見つかりません。',
  },
  filters: {
    searchPlaceholder: '組織名で検索',
    plan: 'プラン設定',
  },
  errors: {
    loadOrganizationsFailed: '組織一覧の取得に失敗しました。',
  },
  create: {
    kicker: 'organization create',
    title: '組織登録',
    description: '新しい組織を登録します。',
    form: {
      title: '登録情報の入力',
      description: '組織名とプランを選択して登録してください。',
      fields: {
        name: {
          label: '組織名',
          placeholder: '例: 株式会社サンプル',
        },
        plan: {
          label: 'プラン設定',
        },
        features: {
          label: '利用機能',
        },
      },
    },
    actions: {
      submit: '登録',
    },
    errors: {
      required: '組織名を入力してください。',
      unauthorized: '認証情報が取得できませんでした。再ログインしてください。',
      submitFailed: '組織登録に失敗しました。',
    },
  },
  edit: {
    kicker: 'organization edit',
    title: '組織編集',
    description: '登録済みの組織情報を更新します。',
    form: {
      title: '更新情報の入力',
      description: '組織名とプランを入力して更新してください。',
      fields: {
        name: {
          label: '組織名',
          placeholder: '例: 株式会社サンプル',
        },
        plan: {
          label: 'プラン設定',
        },
        features: {
          label: '利用機能',
        },
      },
    },
    actions: {
      submit: '更新',
    },
    errors: {
      required: '組織名を入力してください。',
      unauthorized: '認証情報が取得できませんでした。再ログインしてください。',
      submitFailed: '組織更新に失敗しました。',
    },
  },
} as const;

export const friendAnalyticsStrings = {
  title: '友だち分析',
  tabs: { label: '友だち分析の表示切替', overview: '概要', demographics: '属性' },
  description:
    '現在のユーザー数と、LINE公式アカウントごとの友だち追加の累計・ブロック数の推移を確認できます。',
  aggregatedUpTo: '集計完了 $date まで',
  aggregatedUpToUnknown: '集計中です。データが揃うまでお待ちください。',
  pendingChannels:
    '$count件のLINE公式アカウントはまだ集計されておらず、LINE集計に含めていません。',
  staleChannels:
    '$count件のLINE公式アカウントは数値の取得が止まっているため、過去分も含めてLINE集計から除外しています。取得が追いつくと再び集計対象になります。',
  currentUsers: {
    heading: 'ユーザー数（現在・重複なし）',
    description:
      'この画面の読み込み時点の人数です。ユーザー一覧の絞り込み前の総数と同じ条件で数えています。',
    scopeNote:
      'ブロック済み・停止アカウントのユーザーや、チャット参加のみのユーザーも含みます。',
    openUsers: 'ユーザー一覧を開く',
    nonBlocked: 'うちブロックされていないユーザー数',
    nonBlockedNote:
      'ユーザー一覧で友だち状態を「通常」に絞り込んだ件数と同じです。連携解除済みを除くいずれかのアカウントで友だちのままの人を数え、停止アカウントのみのユーザーも含みます。LINE連携なし（チャット参加のみ）のユーザーは含みません。',
    openNonBlockedUsers: 'ブロックされていないユーザーを一覧で見る',
  },
  lineSummaryHeading: 'LINE集計（アカウントごとの延べ数）',
  countDifferenceNote:
    'LINE集計とユーザー一覧では、数える対象と集計時点が異なります。',
  duplicationNote:
    '複数のLINE公式アカウントを友だち追加した同一ユーザーは、その数だけ重複して数えられます。',
  actions: {
    refresh: '再読み込み',
    collect: 'LINEから最新データを取得',
    download: 'ダウンロード',
  },
  // 「LINEから最新データを取得」の結果。取り切れなかった分は次回の押下か毎時の自動取得が拾う
  collect: {
    running: 'LINEからデータを取得しています。しばらくお待ちください。',
    completed: '取得処理を実行しました。$days日分のデータを取得しました。',
    partial:
      '取得処理を実行しました。$days日分のデータを取得しました。まだ取得できていない日があるため、しばらくしてからもう一度お試しください（毎時の自動取得でも埋まります）。',
    busy: '別の取得が進行中です。しばらくしてから再読み込みしてください。',
    upToDate: '取得処理を実行しました。取得できる新しいデータはありませんでした。',
  },
  // 指標の呼び名。タイル・チャート・表・CSVで同じ文言を使うため1箇所で持つ
  metrics: {
    followers: '友だち追加（累計）',
    targetedReaches: 'ターゲットリーチ',
    blocks: 'ブロック',
  },
  helpLabelSuffix: 'の説明',
  help: {
    followers:
      'その日までに友だち追加された累計数です。ブロックや退会をしても減りません。',
    targetedReaches:
      '性別・年代・地域など、LINEが推定した情報で絞り込む配信の候補となる友だちの総数です。たとえば「東京都の30代」といった条件に使います。',
    blocks: '現在ブロックしている人数です。ブロックを解除すると減ります。',
  },
  summary: {
    heading: '友だちの状況',
    comparisonHeading: {
      previousDay: '前日',
      previous7Days: '7日前',
      previous30Days: '30日前',
    },
    unavailable: '-',
  },
  charts: {
    heading: '推移',
    empty: '表示できるデータがありません。',
    ariaLabel: '$metricの日次推移',
  },
  table: {
    heading: '日次データ',
    date: '日付',
    empty: '表示できるデータがありません。',
    sortAscLabel: '日付の古い順に並べ替える',
    sortDescLabel: '日付の新しい順に並べ替える',
  },
  filters: {
    period: '期間',
    presetSuffix: '日間',
  },
  csv: {
    headers: ['日付', '友だち追加（累計）', 'ブロック'],
  },
  errors: {
    loadFailed: '友だち分析の取得に失敗しました。',
    collectFailed: 'LINEからのデータ取得に失敗しました。',
    invalidRange: '開始日は終了日以前の日付を指定してください。',
    rangeTooLong: '期間は最大397日までです。',
    downloadFailed: 'CSVのダウンロードに失敗しました。',
  },
} as const;

export const friendDemographicsStrings = {
  description: '組織のLINE公式アカウントの友だちを、性別・年代・地域の構成比で確認できます。',
  heading: '友だちの属性',
  estimate: '組織全体の概算',
  partialEstimate: '取得できたアカウントの概算',
  freshness: 'LINEが推定した、約3日前の属性情報です。反映のタイミングにより前後する場合があります。',
  method: '各アカウントの割合を、属性取得日の3日前のターゲットリーチで重み付けしています。属性の正確な集計日は公開されていないため、組織全体の構成比は概算です。',
  methodTitle: '集計方法について',
  coverage: '$included / $total アカウントを集計',
  fetchedAt: '属性データ取得：$date',
  referenceDate: '人数の基準日：$from ～ $to',
  pending: '残り$countアカウントの属性を取得しています。',
  unavailable: '$countアカウントはLINE側で属性情報を利用できないため、集計に含めていません。',
  failed: '$countアカウントの属性取得に失敗しました。数分後に再読み込みしてください。',
  missingReach: '$countアカウントは集計に使える人数の基準データがないため、集計に含めていません。',
  noChannels: '連携中のLINE公式アカウントがありません。',
  empty: '表示できる属性データがありません。',
  eligibility: '属性情報は、ターゲットリーチが20人以上で、日本・タイ・台湾のユーザーが作成したLINE公式アカウントで利用できます。',
  loadFailed: '友だちの属性の取得に失敗しました。',
  dimensions: { genders: '性別', ages: '年代', areas: '地域' },
  genderLabels: { male: '男性', female: '女性', unknown: '不明' },
  ageLabels: {
    from0to14: '0〜14歳', from15to19: '15〜19歳', from20to24: '20〜24歳',
    from25to29: '25〜29歳', from30to34: '30〜34歳', from35to39: '35〜39歳',
    from40to44: '40〜44歳', from45to49: '45〜49歳', from50: '50歳以上（旧区分）',
    from50to54: '50〜54歳', from55to59: '55〜59歳', from60to64: '60〜64歳',
    from65to69: '65〜69歳', from70: '70歳以上', unknown: '不明',
  },
  unknown: '不明',
  rank: '順位',
  percentage: '割合',
  csvPercentage: '割合（%）',
  csvIncluded: '集計対象アカウント数',
  csvTotal: '管理対象アカウント数',
  csvReferenceFrom: '人数の基準日（開始）',
  csvReferenceTo: '人数の基準日（終了）',
  csvMethod: '集計方法',
  csvMethodValue: '人数による重み付け（概算）',
  download: 'CSV',
  downloadLabel: '$dimensionのCSVをダウンロード',
  chartLabel: '$dimensionの割合',
  tableLabel: '$dimensionの割合一覧',
  topCategories: 'グラフは割合の大きい上位8区分を表示しています。',
  chartHelp: '左右の矢印キーで区分を切り替えられます。',
} as const;

export const banStatusStrings = {
  title: 'アカウントBAN状況',
  description:
    '全組織のLINE公式アカウントの現在の稼働・停止状況です。時系列の推移は表示しません。',
  actions: {
    refresh: '再読み込み',
  },
  // 分類の呼び名。サマリー・停止理由・絞り込みで同じ文言を使うため1箇所で持つ
  categoryLabels: {
    autoPaused: '自動停止（BAN疑い）',
    manualPaused: '手動停止・Webhook未有効',
    unlinked: '連携解除',
    webhookInvalid: 'Webhook異常',
    notAllocatable: '稼働中だが払い出し不可',
  },
  helpLabelSuffix: 'の説明',
  help: {
    total: 'システムに登録されたアカウントの総数です。連携解除済みも含みます。',
    active:
      '状態が「稼働中」のアカウント数です。友だち追加先として使えるかは、Webhookなどの設定状況にもよります。',
    full:
      '友だち数が、このシステムで設定した上限に達したアカウントです。配信は継続できます。',
    autoPaused:
      'LINE側の認証・利用制限エラーやWebhookの疎通異常を検知して自動停止したアカウントです。BANや凍結が確定した状態ではありません。',
    manualPaused:
      '管理画面で手動停止したアカウント、またはWebhookが有効でないため自動停止したアカウントです。',
    unlinked:
      '管理画面の「連携解除」で、このシステムの運用対象から外したアカウントです。LINE公式アカウント自体は残ります。停止率には含めません。',
    webhookInvalid:
      'LINEからこのシステムへ通知を届けるWebhookの設定の検証に失敗したアカウントです。連携解除済みは含めません。',
    notAllocatable:
      '状態は稼働中または上限到達ですが、Webhook未検証やベーシックID未設定などで、友だち追加先として使えないアカウントです。',
    allocatable:
      '友だち追加やBAN時の別アカウントへの案内に使えるアカウント数です。Webhookの検証とベーシックIDの設定が済んでいる、稼働中・上限到達のアカウントを数えます。',
    pausedRate:
      '連携解除済みを除いたアカウントのうち、自動停止または手動停止・Webhook未有効で停止しているものの割合です。',
    webhook:
      'LINEからメッセージや友だち追加などの通知を受け取るための設定です。「未検証」は確認前、「有効」は設定の確認ができた状態、「無効」は検証に失敗した状態です。',
    updatedAt:
      'アカウント情報が最後に更新された日時です。友だち数の再計算などでも変わるため、停止した時刻とは限りません。',
    totalUsers:
      'この組織のユーザー一覧の絞り込み前の総数です。同じユーザーは1人として数え、ブロック済み・LINE連携なし・テストユーザーも含みます。',
    blockedUsers:
      'ユーザー一覧で「ブロック」だけに絞り込んだ件数です。連携解除済みを除くアカウントに登録があり、それらがすべてブロック状態の人を数えます。別アカウントに未ブロックの登録がある人は含みません。',
    pausedOnlyUsers:
      '自動停止・手動停止のアカウントに未ブロックの登録があり、稼働中・上限到達のアカウントには未ブロックの登録がないユーザー数です。同じユーザーは1人として数え、連携解除済みアカウントは判定対象から外します。',
  },
  summary: {
    heading: '全体',
    total: 'アカウント総数',
    active: '稼働中',
    full: '上限到達',
    allocatable: '払い出し可能',
    pausedRate: '停止率',
  },
  alert: {
    heading: '払い出し可能なアカウントが無い組織',
    description:
      '友だち追加もBAN時の別アカウント誘導も止まっています。優先して対応してください。',
    none: '払い出し可能なアカウントが無い組織はありません。',
    channelSuffix: '件中0件が払い出し可能',
  },
  organizations: {
    heading: '組織別の内訳',
    userCountsNote:
      '総ユーザー数はユーザー一覧の絞り込み前の総数、ブロックユーザー数は「ブロック」だけに絞り込んだ件数と一致します。ブロックと停止アカウントのみのユーザー数はいずれも総数に含まれ、合算する内訳ではありません。',
    userCountsHeading: 'ユーザー数',
    sort: {
      field: '並べ替え項目',
      direction: '並び順',
      noDirection: '—',
      ascending: '昇順',
      descending: '降順',
      default: '初期順（要対応優先）',
      reset: '初期順に戻す',
      actionSuffix: 'で並べ替え',
    },
    headers: {
      organization: '組織',
      plan: 'プラン',
      total: '総数',
      active: '稼働中',
      full: '上限到達',
      allocatable: '払い出し可能',
      totalUsers: '総ユーザー数',
      blockedUsers: 'ブロックユーザー数',
      pausedOnlyUsers: '停止アカウントのみのユーザー数',
    },
    empty: '組織がありません。',
  },
  channels: {
    heading: '払い出しできないアカウント',
    description:
      '停止中・連携解除済み・Webhook未検証など、友だち追加先として払い出せないアカウントです。',
    headers: {
      organization: '組織',
      basicId: 'ベーシックID',
      memo: 'メモ',
      status: '状態',
      category: '分類',
      webhookStatus: 'Webhook',
      friends: '友だち数',
      updatedAt: '最終更新',
    },
    updatedAtNote: '最終更新は友だち数の再計算などでも更新されます。',
    empty: '払い出しできないアカウントはありません。',
    none: '-',
  },
  filters: {
    searchPlaceholder: 'ベーシックID・メモで検索',
    organization: '組織',
    status: '状態',
  },
  states: {
    unknown: '取得できなかったため表示できません。',
    userCountsUnavailable:
      'ユーザー数の一部を取得できていません。「—」は未取得の項目です。再読み込みしてご確認ください。',
  },
  errors: {
    loadFailed: 'BAN状況の取得に失敗しました。',
    loadChannelsFailed: 'アカウント一覧の取得に失敗しました。',
  },
} as const;

export const termsStrings = {
  gate: {
    checking: '利用状態を確認しています…',
    statusFailedTitle: '利用状態を確認できませんでした',
    statusFailedBody:
      '通信状態を確認して再度お試しください。解決しない場合はログアウトして、もう一度ログインしてください。',
    retry: '再試行',
  },
  consent: {
    kicker: 'terms of service',
    title: '利用規約への同意',
    loginLead:
      '利用規約を確認・同意するため、運営から受け取ったメールアドレスとパスワードでログインしてください。',
    reacceptLead:
      '利用規約が改定されました。最新の利用規約をご確認のうえ、同意してからご利用ください。',
    acceptLead:
      'ご利用の前に、以下の利用規約をご確認ください。「利用規約に同意する」を押すと同意が記録されます。',
    versionLabel: '版',
    publishedAtLabel: '公開日',
    acceptButton: '利用規約に同意する',
    accepting: '同意を保存しています…',
    versionChanged:
      '利用規約が更新されました。最新の内容を表示しています。内容をご確認のうえ、改めて同意してください。',
    acceptFailed:
      '同意を保存できませんでした。通信状態を確認して、もう一度お試しください。',
    loadFailed: '利用規約を読み込めませんでした。',
    signOut: 'ログアウト',
    signingOut: 'ログアウトしています…',
    goToApp: '管理画面へ進む',
    verificationTitle: '運営の動作確認中のアカウントです',
    verificationBody:
      'このアカウントは現在、運営が動作確認を行っています。利用規約への同意は不要で、同意は登録されません。',
    notRequiredTitle: '利用規約への同意は不要です',
    notRequiredBody: 'このアカウントでは、現在利用規約への同意手続きは必要ありません。',
    acceptedTitle: '利用規約に同意済みです',
    acceptedBody: 'このアカウントは最新の利用規約に同意済みです。',
    unavailableTitle: '利用規約を取得できませんでした',
    unavailableBody:
      '設定エラーまたは一時的な障害の可能性があります。時間をおいて再度お試しいただくか、運営へお問い合わせください。',
    completedTitle: '利用規約への同意を保存しました',
    completedBody:
      '続けてログアウトします。ログイン画面から、もう一度ログインしてご利用ください。',
    signOutFailed:
      'ログアウトできませんでした。「ログアウトを再試行」を押してください。',
    retrySignOut: 'ログアウトを再試行',
    signedOutAfterConsent:
      '利用規約への同意を保存しました。もう一度ログインしてご利用ください。',
  },
} as const;

export const termsManagementStrings = {
  title: '利用規約管理',
  description:
    '利用規約を登録し、版を公開します。新規クライアントを同意対象とし、既存クライアントはアカウントごとに同意対象へ設定できます。公開した版の本文・版名は変更できません。',
  actions: {
    createDraft: '新しい版を作成',
    view: '表示',
    edit: '編集',
  },
  policy: {
    title: '公開状態',
    activeVersion: '公開中の版',
    noActiveVersion: '公開中の規約はありません',
    consentGeneration: '同意世代',
    enforcement: '利用開始時の同意確認',
    enforcementOn: '有効',
    enforcementOff: '無効（未同意でも利用可能）',
    enforcementUpdated: '最終変更',
    enable: '同意確認を有効にする',
    disable: '同意確認を無効にする',
    enableConfirmTitle: '利用開始時の同意確認を有効にしますか？',
    enableConfirmMessage:
      '新規クライアントと、既存クライアントで個別に指定したアカウントのうち、「利用規約への同意を必須にする」がONのアカウントに同意を求めます。既存クライアントは、追加アカウントも含め、個別にONにするまで対象外です。運営の動作確認中（OFF）のアカウントには影響しません。',
    disableConfirmTitle: '利用開始時の同意確認を無効にしますか？',
    disableConfirmMessage:
      '無効にすると、未同意のアカウントも従来どおり利用できるようになります（障害時の復旧用）。同意履歴は削除されません。',
    enableUnavailable: '規約を公開すると同意確認を有効にできます。',
    enabled: '利用開始時の同意確認を有効にしました。',
    disabled: '利用開始時の同意確認を無効にしました。',
  },
  versions: {
    title: '版の一覧',
    empty: '登録された規約はありません。',
    headers: {
      status: '状態',
      versionLabel: '版',
      title: 'タイトル',
      generation: '同意世代',
      reconsent: '再同意',
      published: '公開日時・公開者',
      actions: '操作',
    },
    status: {
      active: '公開中',
      published: '過去版',
      draft: '下書き',
    },
    reconsent: {
      yes: 'あり',
      no: 'なし',
    },
  },
  editor: {
    createKicker: 'terms draft',
    createTitle: '規約の下書きを作成',
    editTitle: '規約の下書きを編集',
    viewTitle: '公開済みの規約',
    description:
      '本文は顧客の同意画面にそのまま表示されます。内容を確認してから公開してください。',
    publishedNotice:
      '公開済みの版は変更できません。修正が必要な場合は新しい版を作成してください。',
    fields: {
      serviceName: 'サービス名',
      serviceNamePlaceholder: '例: Lbulk',
      title: 'タイトル',
      titlePlaceholder: '例: Lbulk 利用規約',
      versionLabel: '版名',
      versionLabelPlaceholder: '例: 2026年10月版',
      bodyMarkdown: '本文（Markdown）',
      bodyHelper:
        'Markdown で入力します。HTML タグは表示時に無効になります。',
    },
    preview: '顧客画面のプレビュー',
    previewEmpty: '本文を入力するとプレビューを表示します。',
    save: '下書きを保存',
    saving: '保存中…',
    saved: '下書きを保存しました。',
    created: '下書きを作成しました。',
    unsavedBeforePublish: '保存していない変更があります。保存してから公開してください。',
    conflict:
      'この版は他の操作で更新（または公開）されました。編集中の内容はまだ保存されていません。必要な内容を控えてから最新の内容を読み込んでください（編集中の内容は破棄されます）。',
    reloadLatest: '最新の内容を読み込む',
    publish: 'この版を公開する',
    publishTitle: 'この版を公開しますか？',
    publishFirstNotice:
      '初めての公開です。同意確認を有効にすると、同意必須設定ONのアカウントに同意を求めます。既存クライアントは、アカウントごとにONにするまで対象外です。',
    reconsentQuestion: '同意対象のアカウントに再同意を求めますか？',
    reconsentYes: '再同意を求める',
    reconsentYesNote:
      '同意必須設定ONのアカウントに再同意を求めます。既存クライアントで個別にONにしたアカウントも含みます。対象外のアカウントには影響しません。',
    reconsentNo: '再同意を求めない',
    reconsentNoNote:
      '既存の同意者はそのまま利用を続けられます。まだ同意していない利用者は、この版に同意します。',
    publishConfirm: '公開する',
    published: '規約を公開しました。',
    publishedMeta: '公開',
    hashLabel: '本文ハッシュ（SHA-256）',
    errors: {
      required: '必須項目を入力してください。',
      loadFailed: '規約の取得に失敗しました。',
      saveFailed: '下書きの保存に失敗しました。',
      publishFailed: '規約の公開に失敗しました。',
      notFound: '対象の規約が見つかりません。',
    },
  },
  errors: {
    loadPolicyFailed: '公開状態の取得に失敗しました。',
    loadVersionsFailed: '規約の一覧の取得に失敗しました。',
    updateEnforcementFailed: '同意確認の切り替えに失敗しました。',
  },
} as const;

export const accountManagementStrings = {
  title: 'アカウント一覧',
  actions: {
    createAccount: 'アカウント登録',
  },
  messages: {
    createSuccess: 'アカウントを登録しました。',
  },
  table: {
    headers: {
      actions: '操作',
      id: 'ID',
      organization: '組織名',
      name: '利用者名',
      role: '権限',
      email: 'メールアドレス',
      status: 'ステータス',
      terms: '利用規約',
    },
  },
  states: {
    empty: 'アカウントがありません。',
  },
  terms: {
    states: {
      NOT_APPLICABLE: '対象外（運営）',
      EXEMPT: '対象外（既存クライアント）',
      VERIFICATION: '動作確認中',
      PENDING: '同意待ち',
      REACCEPTANCE_PENDING: '再同意待ち',
      ACCEPTED: '同意済み',
    },
    sectionTitle: '利用規約への同意',
    sectionDescription:
      '同意の設定はアカウントごとに管理します。新規クライアントでは、動作確認が完了し、顧客へ資格を渡す前にONにします。ONにしても本人の同意は代行されません。',
    exemptNotice:
      'このアカウントは現在、同意の対象外です。同意を求めたい場合は、このアカウントだけをONにできます。同じ組織の他のアカウントや、今後追加するアカウントには影響しません。',
    exempt: '対象外',
    labels: {
      setting: '利用規約への同意を必須にする',
      state: '同意状態',
      changedBy: '設定変更者・日時',
      latestAcceptance: '同意した版・日時',
      history: '同意履歴',
      consentUrl: '顧客へ渡す規約同意URL',
    },
    on: 'ON',
    off: 'OFF（運営の動作確認中）',
    migrated: '既定値（既存アカウント）',
    noAcceptance: '未同意',
    noHistory: '同意履歴はありません。',
    enable: '利用規約への同意を必須にする',
    enableConfirmTitle: '利用規約への同意を必須にしますか？',
    enableConfirmMessage:
      '顧客へ渡す前に動作確認を完了してください。ON以降、未同意の利用者は規約画面に案内されます。\nONにした後は、この画面からOFFへ戻すことはできません。',
    exemptEnableConfirmMessage:
      'このアカウントだけを同意対象にします。必要な同意が済んでいない場合、次の利用時に規約画面に案内されます。同じ組織の他のアカウントや、今後追加するアカウントには影響しません。\nONにした後は、この画面からOFFへ戻すことはできません。',
    enableConfirm: 'ONにする',
    enabled:
      '同意必須設定をONにしました。必要な同意が済んでいない場合、次の利用時に規約画面に案内されます。規約同意URLも共有できます。',
    enableFailed: '同意必須設定の変更に失敗しました。',
    loadFailed: '利用規約の同意状態の取得に失敗しました。',
    unavailableNotice:
      '公開中の利用規約がないか、利用開始時の同意確認が無効のため、ONにできません。利用規約管理で規約を公開し、同意確認を有効にしてください。',
    adminNotice: '運営（ADMIN）アカウントは同意の対象外です。',
    enforcementOffNotice:
      '利用開始時の同意確認が無効のため、未同意でも利用できる状態です。',
    copyUrl: 'URLをコピー',
    copied: 'コピーしました',
  },
  filters: {
    searchPlaceholder: 'ID / 組織名 / 利用者名 / メールアドレスで検索',
    organization: '組織名',
    role: '権限',
    status: 'ステータス',
  },
  errors: {
    loadAccountsFailed: 'アカウント一覧の取得に失敗しました。',
  },
  create: {
    kicker: 'account create',
    title: 'アカウント登録',
    description: '組織メンバー用のログインアカウントを登録します。',
    form: {
      title: '登録情報の入力',
      description:
        '登録したメールアドレスとパスワードで、管理画面へログインできます。',
      fields: {
        organization: {
          label: '所属組織',
        },
        name: {
          label: '利用者名',
          placeholder: '例: 山田 太郎',
        },
        email: {
          label: 'メールアドレス',
          placeholder: '例: user@example.com',
        },
        password: {
          label: '初期パスワード',
          placeholder: '6文字以上で入力してください',
        },
        role: {
          label: '権限',
        },
      },
      roleOptions: {
        admin: 'ADMIN',
        standard: 'STANDARD',
      },
    },
    actions: {
      submit: '登録',
    },
    errors: {
      required: '必須項目を入力してください。',
      organizationRequired: '所属組織を選択してください。',
      passwordTooShort: 'パスワードは6文字以上で入力してください。',
      noOrganizations: '組織が未登録のため、先に組織を登録してください。',
      unauthorized: '認証情報が取得できませんでした。再ログインしてください。',
      submitFailed: 'アカウント登録に失敗しました。',
      emailExists:
        'このメールアドレスは既に登録されています。既存のアカウントに所属組織を追加してください。',
      openExistingAccount: '既存アカウントを開く',
    },
  },
  edit: {
    kicker: 'account edit',
    title: 'アカウント編集',
    description: 'アカウント情報を更新します。',
    summary: {
      title: '基本情報',
      emptyValue: '-',
      labels: {
        id: 'ID',
        organization: '所属組織',
        createdAt: '登録日時',
        updatedAt: '更新日時',
      },
    },
    form: {
      title: '編集内容',
      description:
        'プロフィールと認証情報を変更できます。パスワードは必要な場合のみ入力してください。',
      fields: {
        name: {
          label: '利用者名',
          placeholder: '例: 山田 太郎',
        },
        email: {
          label: 'メールアドレス',
          placeholder: '例: user@example.com',
        },
        role: {
          label: '権限',
        },
        status: {
          label: 'ステータス',
        },
        newPassword: {
          label: '新しいパスワード',
          placeholder: '6文字以上で入力してください',
          helper: '変更しない場合は空欄にしてください。',
        },
        newPasswordConfirm: {
          label: '新しいパスワード（確認）',
          placeholder: '再入力してください',
        },
      },
      roleOptions: {
        admin: 'ADMIN',
        standard: 'STANDARD',
      },
      statusOptions: {
        active: 'ACTIVE',
        paused: 'PAUSED',
      },
    },
    messages: {
      updateSuccess: 'アカウントを更新しました。',
      securityOnlyFailed:
        '基本情報は更新しましたが、認証情報の更新に失敗しました。',
    },
    states: {
      notFound: '対象のアカウントが見つかりません。',
    },
    memberships: {
      title: '所属組織',
      description:
        'このアカウントが利用できる組織と状態を管理します。停止した組織の画面は開けなくなり、通知も届きません。',
      headers: {
        organization: '組織名',
        status: 'ステータス',
        actions: '操作',
      },
      statuses: {
        active: 'ACTIVE',
        paused: 'PAUSED',
      },
      actions: {
        pause: '停止',
        activate: '有効化',
      },
      pauseConfirm: {
        title: '所属を停止しますか？',
        message:
          '停止すると、このアカウントはその組織の画面を開けなくなり、通知も届かなくなります。',
        confirm: '停止する',
      },
      activateConfirm: {
        title: '所属を有効化しますか？',
        message: '有効化すると、このアカウントはその組織を再び利用できます。',
        confirm: '有効化する',
      },
      add: {
        title: '所属組織を追加',
        organizationLabel: '組織',
        placeholder: '組織を選択してください',
        submit: '追加',
        success: '所属組織を追加しました。',
        noCandidates: '追加できる組織がありません。',
      },
      messages: {
        updateSuccess: '所属の状態を更新しました。',
      },
      states: {
        empty: '所属組織がありません。',
      },
      errors: {
        updateFailed: '所属の状態を更新できませんでした。',
        addFailed: '所属組織を追加できませんでした。',
        adminSingleMembership:
          'ADMIN の所属は1件に制限されています。権限を STANDARD に変更してから追加してください。',
        activeAdminRequired:
          '組織に有効な ADMIN がいなくなるため、この変更はできません。',
        selfMembershipPauseForbidden:
          '自分自身の所属を停止することはできません。',
      },
    },
    errors: {
      loadFailed: 'アカウント情報の取得に失敗しました。',
      required: '必須項目を入力してください。',
      emailInvalid: 'メールアドレスの形式が不正です。',
      passwordTooShort: 'パスワードは6文字以上で入力してください。',
      passwordConfirmMismatch:
        '新しいパスワードと確認用パスワードが一致しません。',
      unauthorized: '認証情報が取得できませんでした。再ログインしてください。',
      updateFailed: 'アカウント更新に失敗しました。',
      // プロフィール PATCH が返す 409（I6・I7）は backend の生 message ではなく定型文言で伝える
      adminSingleMembership: '管理者は1つの組織にのみ所属できます。',
      activeAdminRequired:
        '組織に有効な管理者が1人以上必要なため更新できません。',
    },
  },
} as const;

export const tagManagementStrings = {
  title: 'タグ管理',
  actions: {
    createTag: 'タグ登録',
  },
  messages: {
    createSuccess: 'タグを登録しました。',
    updateSuccess: 'タグを更新しました。',
    deleteSuccess: 'タグを削除しました。',
  },
  table: {
    headers: {
      actions: '操作',
      tag: 'タグ',
      friendCount: '友だち数',
      createdAt: '作成日',
    },
  },
  states: {
    empty: 'タグがありません。',
  },
  errors: {
    loadTagsFailed: 'タグ一覧の取得に失敗しました。',
    deleteFailed: 'タグの削除に失敗しました。',
    unauthorized: '認証情報が取得できませんでした。再ログインしてください。',
  },
  delete: {
    title: 'タグを削除しますか？',
    message: 'このタグを削除すると、友だちへの付与もすべて解除されます。',
    confirm: '削除する',
  },
  form: {
    colorLabel: '色',
    preview: 'プレビュー',
    fields: {
      name: {
        label: 'タグ名',
        placeholder: '例: VIP',
      },
    },
  },
  colorNames: {
    gray: 'グレー',
    red: 'レッド',
    orange: 'オレンジ',
    yellow: 'イエロー',
    green: 'グリーン',
    blue: 'ブルー',
    purple: 'パープル',
    pink: 'ピンク',
  },
  create: {
    kicker: 'tag create',
    title: 'タグ登録',
    description: '友だちに付与するタグを登録します。',
    form: {
      title: '登録情報の入力',
      description: 'タグ名と色を選択して登録してください。',
    },
    actions: {
      submit: '登録',
    },
    errors: {
      required: 'タグ名を入力してください。',
      unauthorized: '認証情報が取得できませんでした。再ログインしてください。',
      submitFailed: 'タグの登録に失敗しました。',
    },
  },
  edit: {
    kicker: 'tag edit',
    title: 'タグ編集',
    description: '登録済みのタグを更新します。',
    form: {
      title: '編集内容の入力',
      description: 'タグ名と色を入力して更新してください。',
    },
    actions: {
      submit: '更新',
    },
    states: {
      notFound: '対象のタグが見つかりません。',
    },
    errors: {
      required: 'タグ名を入力してください。',
      unauthorized: '認証情報が取得できませんでした。再ログインしてください。',
      submitFailed: 'タグの更新に失敗しました。',
    },
  },
  editForFriend: {
    title: 'タグ',
    description: '友だちに付与するタグを選択してください。',
    empty: 'タグがありません。タグ管理から作成できます。',
  },
  // 一斉送信の宛先選択でも使うため、画面単位の editForFriend とは分ける。
  selector: {
    selectedCount: (count: number) => `${count}件選択中`,
    noneSelected: 'タグ未選択',
  },
} as const;

export const lineStrings = {
  providerNotice: [
    '※システムに連携するLINE公式アカウント(MessagingAPI)はすべて同一プロバイダーを選択する必要があります。',
    '※複数のプロバイダーをまたいでMessagingAPI連携すると正しくシステム挙動しない場合がありますのでご注意ください。',
  ],
  management: {
    title: '連携済みLINEアカウント',
    connectButton: 'LINEアカウント連携',
    actions: {
      verify: '検証・修復',
      unlink: '連携解除',
      viewMemo: '全文',
    },
    messages: {
      unlinkSuccess: 'LINEアカウントの連携を解除しました。',
      verifySuccess: 'Webhook URLの検証・修復に成功しました。',
      verifyFailed: 'Webhook URLの検証・修復に失敗しました。',
    },
    confirm: {
      verifyTitle: 'Webhook URLを検証・修復しますか？',
      verifyDescription:
        'Webhook URLを現在の環境向けに再登録し、疎通を検証します。他の環境に設定されたURLは上書きされます。',
      verifyConfirm: '検証・修復する',
      unlinkTitle: 'LINE連携を解除しますか？',
      unlinkDescription:
        '解除するとこのアカウントは一覧画面から非表示になります。',
      unlinkConfirm: '解除する',
    },
    table: {
      headers: {
        id: 'ID',
        channelId: 'チャネルID',
        basicId: 'ベーシックID',
        memo: 'メモ',
        friendLimit: '友だち上限数',
        activeFriends: '友だち数',
        status: 'ステータス',
        webhookStatus: 'Webhook状態',
        webhookVerify: 'Webhook検証・修復',
        actions: '操作',
      },
    },
    states: {
      empty: 'LINEアカウントが連携されていません。',
    },
    filters: {
      searchPlaceholder: 'ベーシックIDで検索',
      status: 'ステータス',
      webhookStatus: 'Webhook状態',
      webhookEnabled: '有効',
      webhookDisabled: '無効',
    },
    errors: {
      loadAccountsFailed: 'LINEアカウントの取得に失敗しました。',
      unauthorized: '認証情報が取得できませんでした。再ログインしてください。',
      verifyFailed: 'Webhook URLの検証・修復に失敗しました。',
      unlinkFailed: 'LINEアカウント連携の解除に失敗しました。',
    },
    bulk: {
      selectAllLabel: 'すべて選択',
      selectRowLabel: '行を選択',
      selectedSuffix: '件を選択中',
      clearSelection: '選択を解除',
      actions: {
        verify: 'Webhook一括検証・修復',
        status: 'ステータス変更',
        friendLimit: '友だち上限数変更',
      },
      verifyConfirm: {
        title: '選択したチャンネルを検証・修復しますか？',
        description:
          '{{count}}件のWebhook URLを現在の環境向けに再登録し、疎通を検証します。他の環境に設定されたURLは上書きされます。',
        confirm: '検証・修復する',
      },
      statusModal: {
        title: 'ステータスを一括変更',
        description: '選択した{{count}}件のステータスを変更します。',
        submit: '変更する',
        options: {
          active: '配信を再開します',
          paused: '配信を停止します',
          full: '友だち上限に達した状態にします',
        },
      },
      friendLimitModal: {
        title: '友だち上限数を一括変更',
        description: '選択した{{count}}件の友だち上限数を変更します。',
        label: '友だち上限数',
        placeholder: '例: 5',
        submit: '変更する',
      },
      result: {
        success: '{{count}}件処理しました',
        partial: '成功{{successful}}件 / 失敗{{failed}}件',
        failureDetailPrefix: '{{name}}: ',
      },
      errors: {
        invalidFriendLimit: '友だち上限数は0以上の整数で入力してください。',
        operationFailed: '一括処理に失敗しました。',
      },
    },
    migration: {
      button: '移行',
      title: '移行',
      selectAll: 'すべて選択',
      start: '移行開始',
      processing: '移行中...',
      complete: '移行完了',
      noEligibleChannels: '移行可能なチャンネル（ACTIVE/FULL）がありません。',
      errors: {
        migrationFailed: '移行に失敗しました。',
        unauthorized: '認証エラーが発生しました。',
      },
      migrationMessage: {
        send: '移行メッセージ送信',
        sendAll: '移行メッセージを一括送信',
        sending: '送信中...',
        sendComplete: '送信完了',
        noTargets: '送信対象の友だちがいません',
        errors: {
          sendFailed: '移行メッセージの送信に失敗しました。',
          unauthorized: '認証エラーが発生しました。',
        },
      },
      crawl: {
        crawlTitle: '友だち情報の取得',
        migrateTitle: '友だち情報の移行',
        urlLabel: 'LPRO URL',
        urlPlaceholder: 'https://example.com/manage',
        loginIdLabel: 'ログインID',
        loginPassLabel: 'パスワード',
        startButton: '取得開始',
        crawlingPhase: '友だち情報を取得中...',
        migratingPhase: '友だち情報を移行中...',
        confirmMessage: '友だち情報を移行してよろしいですか？',
        confirmButton: 'はい、移行する',
        completed: '移行完了',
        csvTab: {
          crawlTab: '② 友だち情報の取得',
          migrateTab: '② 友だち',
          downloadCsv: 'CSVダウンロード',
          downloadFailed: 'CSVダウンロードに失敗しました。',
          uploadCsv: 'CSVファイルを選択',
          uploadedCount: '件のエントリ',
          previewTitle: 'プレビュー',
          previewMore: '他',
          previewMoreSuffix: '件',
          confirmMigrate: '移行してよろしいですか？',
          startMigrate: '移行実行',
          crawlComplete: '件の友だち情報を取得しました',
          migrateResult: '作成',
          migrateResultSkipped: 'スキップ',
          migrateResultFailed: '失敗',
          migrateErrors: '移行できなかった友だち',
          migrateErrorsSuffix: '件',
          messageResult: '送信',
          messageResultFailed: '失敗',
          channelCrawlTab: '① LINEアカウントの取得',
          channelRegisterTab: '① LINEアカウント',
          channelCrawlComplete: '件のLINEアカウント情報を取得しました',
          channelRegisterResult: '登録',
          channelRegisterResultSkipped: 'スキップ',
          channelRegisterResultFailed: '失敗',
          channelRegisterErrors: '登録できなかったアカウント',
          channelConfirmRegister:
            'LINEアカウントを一括登録してよろしいですか？',
          channelStartRegister: '登録実行',
          channelRegisterDoneHint:
            'LINEアカウントの登録が完了しました。続けて「② 友だち」の取得・登録を行ってください。',
          migrationGuide1: '① LINEアカウントのCSVをアップロードして登録',
          migrationGuide2: '② 友だち情報のCSVをアップロードして登録',
          channelUploadCsv: 'CSVファイルを選択',
        },
        errors: {
          crawlFailed: '友だち情報の取得に失敗しました。',
          migrateFailed: '友だち情報の移行に失敗しました。',
          channelCrawlFailed: 'LINEアカウント情報の取得に失敗しました。',
          channelRegisterFailed: 'LINEアカウントの登録に失敗しました。',
          unauthorized: '認証エラーが発生しました。',
        },
      },
    },
    richMenu: {
      createTitle: 'リッチメニュー',
      createDescription:
        '組織に連携している全LINE公式アカウントに、同じリッチメニューを適用します。',
      backToLine: 'LINE管理へ',
      noChannelsHint:
        '稼働中のLINEチャンネルがありません。LINE管理で連携状況を確認してください。',
      create: {
        menuContent: 'メニュー内容',
        templateLabel: 'テンプレート',
        templateChange: '変更',
        imageShortLabel: '画像',
        imageSelectButton: '選択',
        actionsSectionTitle: 'アクション',
        urlPlaceholder: 'https://example.com または info@example.com',
        actionLabelPlaceholder:
          'リンクラベル（例: リンクを開く、ホームページ など）',
        actionTypeOptionNone: 'なし',
        actionTypeOptionUri: 'リンク',
        actionTypeOptionMessage: 'メッセージ',
        actionTypeOptionMail: 'メール',
        mailAddress: 'メールアドレス',
        mailAddressPlaceholder: 'support@example.com',
        mailSubject: '件名（任意）',
        mailSubjectPlaceholder: 'お問い合わせ',
        mailBody: '本文（任意）',
        mailBodyPlaceholder: 'メール本文の下書きを入力',
        mailHint:
          'タップすると端末の既定ブラウザで確認ページが開き、そこからメールアプリに宛先・件名・本文が渡されます。',
        templateModalTitle: 'テンプレートを選択',
        templateModalLargeTitle: '大（推奨 1200 × 810 px）',
        templateModalLargeDescription:
          'より多くの項目を表示するための大きなメニューです。',
        templateModalCompactTitle: 'コンパクト（推奨 1200 × 405 px）',
        templateModalCompactDescription:
          'トーク画面の下部に表示される、控えめなメニューです。',
        templateModalCancel: 'キャンセル',
        templateModalApply: '適用',
        imageLabel: '背景画像',
        selectImageButton: '画像を選択',
        imageHint:
          'JPG / JPEG / PNG・1MB以下・幅800〜2500px・高さ250px以上・横幅÷高さ1.45以上',
        areasTitle: 'タップ領域',
        actionType: 'アクション種別',
        actionLabel: 'ラベル（任意・最大20文字）',
        uri: 'URL・メールアドレス',
        text: 'テキスト',
        messageTextHint:
          'チャットのキーワードなど、表示するテキストを入力してください（50文字以内）。',
        messageTextPlaceholder: 'テキストを入力',
        chatBarMenu: 'メニュー',
        defaultMenuName: 'リッチメニュー',
        save: '全アカウントに適用',
        submitSuccess: '全LINEアカウントにリッチメニューを適用しました',
        submitSuccessPartial:
          '{{applied}}件に適用しました。失敗{{failed}}件、未処理{{deferred}}件です。',
        clearDefault: {
          action: 'デフォルト設定を解除',
          confirmTitle: 'リッチメニューを解除しますか？',
          confirm: '解除する',
          success:
            '全LINEアカウントのデフォルト設定を解除しました。反映には最大1分程度かかる場合があります。',
          successPartial:
            '{{cleared}}件を解除し、{{alreadyCleared}}件は解除済みでした。{{failed}}件は失敗しました。再度お試しください。',
        },
        showOutlines: 'テンプレートを表示',
        phonePreviewTitle: 'プレビュー',
        errors: {
          loadTemplatesFailed: 'テンプレートの取得に失敗しました。',
          loadCurrentRichMenuFailed:
            '現在のリッチメニューの取得に失敗しました。',
          applyAllFailed: '適用に失敗しました。',
          submitFailed:
            'リッチメニューの送信に失敗しました。時間をおいて再度お試しください。',
          clearDefaultFailed:
            'デフォルト設定の解除に失敗しました。時間をおいて再度お試しください。',
          imageRequired: '画像を選択してください。',
          imageTooLarge: '画像は1MB以下にしてください。',
          imageTypeInvalid: 'JPG / JPEG / PNG形式の画像を選択してください。',
          imageUnreadable:
            '画像を読み込めませんでした。別の画像を選択してください。',
          imageDimensionsInvalid:
            '画像サイズがLINEの要件を満たしていません（{{width}}×{{height}}px）。幅800〜2500px・高さ250px以上・横幅÷高さ1.45以上の画像を選択してください。',
          uriRequired: 'URLまたはメールアドレスを入力してください。',
          uriInvalid:
            'http / https / line / tel で始まる有効なURLを入力してください。',
          uriTooLong: 'URLは1000文字以内にしてください。',
          mailAddressRequired: 'メールアドレスを入力してください。',
          mailAddressInvalid: '有効なメールアドレスを入力してください。',
          mailContentTooLong:
            '件名と本文が長すぎます。短くしてください。',
          textRequired: 'テキストを入力してください。',
          textTooLong: 'テキストは50文字以内にしてください。',
          labelTooLong: 'ラベルは20文字以内にしてください。',
          surveyRequired: 'アンケートを選択してください。',
          nameTooLong: 'メニュー名は300文字以内にしてください。',
          chatBarTooLong: 'チャットバーの文言は14文字以内にしてください。',
        },
      },
    },
    cardTypeMessage: {
      createTitle: 'カードタイプメッセージ',
      createDescription:
        'テンプレートを選び、カードの内容を設定して自動応答などで使う素材を登録します。',
      listNew: '新規',
      itemName: 'アイテム名',
      itemNameHint:
        'アイテム名はプッシュ通知やユーザーのチャット一覧に表示されます。',
      itemId: 'ID',
      itemIdHint: '作成後に発行',
      altText: '代替テキスト',
      cardTypeLabel: 'カードタイプ',
      changeType: '変更',
      addCard: 'カードを追加',
      addClosingCard: 'クロージングカードを追加',
      deleteCard: 'カードを削除',
      reorderCards: 'カードを並び替え',
      reorderModalTitle: 'カードの並び順を変更',
      reorderModalDescription:
        'カードをドラッグするか移動先を選んで、LINEで表示する順番に並び替えてください。',
      reorderModalHint:
        'カードのハンドルをドラッグして移動できます。キーボードではハンドルにフォーカスし、Spaceキーで持ち上げて矢印キーで移動します。',
      reorderDragHandle: 'ドラッグして移動',
      reorderPreview: 'フルプレビューを表示',
      reorderClosePreview: 'プレビューを閉じる',
      reorderMoveTo: '移動先',
      reorderPositionLabel: '番目',
      cardTab: 'カード',
      carouselPrev: '前のカード',
      carouselNext: '次のカード',
      templateModalTitle: 'カードタイプを選択',
      templateModalCancel: 'キャンセル',
      templateModalApply: '適用',
      save: '保存',
      delete: '削除',
      uploadImage: '画像をアップロード',
      defaultImage: 'デフォルト画像',
      images: '画像',
      imageRecommendations: {
        productsPlacesSingle: '推奨サイズ：1024×678px（約1.51:1）',
        productsPlacesDouble: '推奨サイズ：A・B 各1024×1024px（1:1）',
        productsPlacesTriple:
          '推奨サイズ：A 1024×1024px（1:1）、B・C 各1024×512px（2:1）',
        square: '推奨サイズ：1024×1024px（1:1）',
      },
      tag: 'タグ',
      tag1: 'タグ 1',
      tag2: 'タグ 2',
      tag3: 'タグ 3',
      enterTagText: 'タグテキストを入力',
      header: 'ヘッダー',
      enterHeader: 'ヘッダーを入力',
      name: '名前',
      enterName: '名前を入力',
      description: '説明',
      enterDescription: '説明を入力',
      price: '価格',
      price2: '価格 2',
      priceLabel: '項目名',
      enterPriceLabel: '項目名を入力',
      address: '住所',
      enterAddress: '住所を入力',
      additionalInfo: '追加情報',
      enterInfoDetails: '詳細情報を入力',
      action1: 'アクション 1',
      action2: 'アクション 2',
      enterActionLabel: 'アクションラベルを入力',
      actionType: 'アクションタイプ',
      actionTypeSelect: '選択',
      actionTypeText: 'テキスト',
      actionTypeUri: 'URL',
      enterUri: 'URLを入力',
      enterText: 'テキストを入力',
      errors: {
        nameRequired: 'アイテム名を入力してください。',
        altTextRequired: '代替テキストを入力してください。',
        altTextTooLong: '代替テキストは1500文字以内にしてください。',
        headerRequired: 'ヘッダーを入力してください。',
        nameFieldRequired: '名前を入力してください。',
        imageRequired: '画像を選択してください。',
        imageInvalidType: 'JPEGまたはPNG形式の画像を選択してください。',
        imageTooLarge: '画像は10MB以下にしてください。',
        imageDimensionsTooLarge: '画像サイズは1024×1024px以内にしてください。',
        imageDecodeFailed:
          '画像を読み込めませんでした。別のJPEGまたはPNG画像を選択してください。',
        imageUploadFailed:
          '画像のアップロードに失敗しました。時間をおいて再度お試しください。',
        labelRequired: 'アクションラベルを入力してください。',
        actionTypeRequired: 'アクションタイプを選択してください。',
        textRequired: 'テキストを入力してください。',
        textTooLong: 'テキストは300文字以内にしてください。',
        tagTextRequired: 'タグを入力してください。',
        descriptionRequired: '説明を入力してください。',
        priceRequired: '価格を入力してください。',
        price2Required: '2つ目の価格を入力してください。',
        addressRequired: '住所を入力してください。',
        additionalInfoRequired: '詳細情報を入力してください。',
        maxCardsReached: 'カードは最大9枚まで追加できます。',
        uriRequired: 'URLを入力してください。',
        uriTooLong: 'URLは1000文字以内にしてください。',
        uriInvalid:
          'http / https / line / tel で始まる有効なURLを入力してください。',
        saveFailed: '保存に失敗しました。',
        deleteFailed: '削除に失敗しました。',
      },
    },
    richMessage: {
      createTitle: 'リッチメッセージ',
      createDescription:
        '画像とタップ領域を設定し、自動応答などで使うリッチメッセージ素材を登録します。',
      listNew: '新規',
      templateLabel: 'テンプレート',
      templateChange: '変更',
      altTextLabel: '代替テキスト',
      nameLabel: '名称',
      imageHint:
        'テンプレートに合った画像をアップロードしてください（幅1040px推奨）。',
      save: '保存',
      delete: '削除',
      templateModalTitle: 'テンプレートを選択',
      templateModalCancel: 'キャンセル',
      templateModalApply: '適用',
      categorySquare: 'Square',
      categoryLandscape: 'Landscape',
      categoryPortrait: 'Portrait',
      categoryCustom: 'Custom',
      customSizeHint: 'Custom（1040 × 520–2080 pixels）',
      actionsSectionTitle: 'アクション',
      actionTypeOptionNone: 'なし',
      actionTypeOptionUri: 'リンク',
      actionTypeOptionMessage: 'メッセージ',
      urlPlaceholder: 'URLを入力',
      messageTextPlaceholder: 'テキストを入力',
      templatesLoading: '読み込み中…',
      templatesLoadFailed: 'テンプレートを読み込めませんでした',
      repairWarning:
        '旧形式または不正な素材です。Scenarioでは使用できません。新形式として修復して保存してください。',
      repairHint:
        'テンプレートとアクションを選び直し、画像を復元できない場合は再アップロードしてから保存してください。保存するまで既存の素材は変更されません。',
      errors: {
        nameRequired: '名称を入力してください。',
        altTextRequired: '代替テキストを入力してください。',
        imageRequired: '画像を選択してください。',
        imageTooLarge: '10MB以上の画像は登録できません。',
        imageWidthInvalid: '画像の幅は1040pxである必要があります。',
        imagemapImageRequired:
          'Imagemap用の画像形式が古いです。画像を再アップロードしてください。',
        customHeightInvalid:
          'Customテンプレートの高さは520〜2080pxの範囲です。',
        uriRequired: 'URLを入力してください。',
        uriInvalid:
          'http / https / line / tel で始まる有効なURLを入力してください。',
        uriTooLong: 'URLは1000文字以内にしてください。',
        textRequired: 'テキストを入力してください。',
        textTooLong: 'テキストは50文字以内にしてください。',
        labelTooLong: 'ラベルは20文字以内にしてください。',
        saveFailed: '保存に失敗しました。',
        imageUploadFailed: '画像のアップロードに失敗しました。',
      },
    },
  },
  connect: {
    kicker: 'line account connect',
    title: 'LINEアカウント連携',
    description: '連携に必要な情報を準備して、アカウント連携を開始します。',
    actions: {
      submit: '連携',
    },
    errors: {
      required: '必須項目を入力してください。',
      unauthorized: '認証情報が取得できませんでした。再ログインしてください。',
      submitFailed: 'LINEアカウント連携に失敗しました。',
    },
    warnings: {
      webhookPaused:
        'チャンネルは登録されましたが、Webhook検証に失敗したためPAUSED状態です。LINE管理画面からWebhook検証を実行してください。',
    },
    form: {
      title: '連携情報の入力',
      description:
        'LINE Official Account Managerで確認した情報を入力してください。',
      fields: {
        basicId: {
          label: 'ベーシックID',
          placeholder: '例: lineban',
        },
        channelId: {
          label: 'チャネルID',
          placeholder: '例: 1234567890',
        },
        channelSecret: {
          label: 'チャネルシークレット',
          placeholder: '例: 1a2b3c4d5e6f...',
        },
      },
    },
  },
  edit: {
    kicker: 'line account edit',
    title: 'LINEアカウント編集',
    description: '連携済みアカウントの情報を更新します。',
    statusOptions: {
      active: 'ACTIVE（稼働）',
      paused: 'PAUSED（停止）',
      full: 'FULL（上限到達）',
      unlinked: 'UNLINKED（連携解除）',
    },
    webhookStatusLabels: {
      verified: '有効',
      invalid: '無効',
      unverified: '未検証',
    },
    errors: {
      loadFailed: 'LINEアカウントの取得に失敗しました。',
      required: '必須項目を入力してください。',
      invalidFriendLimit: '友だち上限は0以上の数値で入力してください。',
      unauthorized: '認証情報が取得できませんでした。再ログインしてください。',
      reissueFailed: 'アクセストークンの再発行に失敗しました。',
      updateFailed: 'LINEアカウントの更新に失敗しました。',
    },
    states: {
      notFound: '対象のLINEアカウントが見つかりません。',
    },
    webhookAlert: {
      unverified:
        'Webhookが未検証です。LINE Official Account Managerの「設定 > 応答設定 > Webhook」で有効化し、下部の「検証・修復」ボタンを実行してください。',
      invalid:
        'Webhook検証に失敗しています。LINE Official Account ManagerでWebhookが有効になっているか確認し、「検証・修復」ボタンを実行してください。',
    },
    summary: {
      title: '連携中のアカウント',
      description: '編集対象のアカウント情報を確認できます。',
      emptyValue: '-',
      labels: {
        id: 'ID',
        basicId: 'ベーシックID',
        channelId: 'チャネルID',
      },
    },
    form: {
      title: '編集内容の入力',
      description: '更新したい項目を修正してください。',
      actions: {
        reissueToken: 'アクセストークン再発行',
        reissueSuccess: '再発行しました',
      },
      sections: {
        statusInfo: 'ステータス情報',
      },
      fields: {
        basicId: {
          label: 'ベーシックID',
          placeholder: '例: lineban',
        },
        channelId: {
          label: 'チャネルID',
          placeholder: '例: 1234567890',
        },
        channelSecret: {
          label: 'チャネルシークレット',
          placeholder: '例: 1a2b3c4d5e6f...',
        },
        accessToken: {
          label: 'アクセストークン',
        },
        friendLimit: {
          label: '友だち上限',
          placeholder: '例: 5',
        },
        status: {
          label: 'ステータス',
        },
        activeFriends: {
          label: '友だち数',
        },
        webhookStatus: {
          label: 'Webhookステータス',
        },
        memo: {
          label: 'メモ',
          placeholder: '運用メモや注意点を入力',
          helper: '最大1000文字',
        },
      },
    },
  },
} as const;

export const messageStrings = {
  responseStatus: {
    label: '対応ステータス',
    NEEDS_RESPONSE: '要対応',
    RESPONDED: '対応済み',
    NO_ACTION_NEEDED: '対応不要',
    needsResponseOnly: '要対応のみ',
    updateFailed: '対応ステータスの変更に失敗しました',
  },
  image: '「画像」',
  pdfSent: 'PDFを送信しました',
  unsupportedFileType: '画像・動画・PDF・ZIP以外のファイルは送信できません',
  uploadFailed: 'ファイルのアップロードに失敗しました',
  pdfFileName: 'PDFファイル',
  pdfUnavailable: 'このPDFは開けません',
  pdfLimitSize: 'PDFは$sizeを超えてはなりません',
  videoSent: '動画を送信しました',
  videoLimitSize: '動画は$sizeを超えてはなりません',
  zipSent: 'ZIPを送信しました',
  zipFileName: 'ZIPファイル',
  zipUnavailable: 'このZIPは開けません',
  zipLimitSize: 'ZIPは$sizeを超えてはなりません',
  inputPlaceholder: 'メッセージを入力...',
  isTyping: 'が入力しています',
  startMessage: '会話を始めます。',
  saveDraftSuccess: '下書きを保存しました',
  aiSuggestTitle: 'AI回答候補',
  aiHistoryTitle: 'AI回答履歴',
  aiMessageMenuLabel: 'メッセージメニュー',
  aiGenerating: '回答候補を生成中...',
  aiHistoryLoading: '履歴を読み込み中...',
  aiRegenerate: '再生成',
  aiNoHistory: '履歴がありません',
  aiSuggestFailed: 'AI回答候補の取得に失敗しました',
  aiSuggestNoAnswer: '回答候補がありません',
  aiTargetMessage: '対象メッセージ',
  aiCopyAnswer: '回答をコピー',
  aiCopyAnswerSuccess: 'コピーしました',
  aiCopyAnswerError: 'コピーに失敗しました',
  recallMessage: 'メッセージを取り消す',
  recallMessageConfirmTitle: 'メッセージを取り消す',
  recallMessageConfirmMessage:
    'このメッセージを取り消しますか？相手の画面からは表示されなくなります。',
  recallMessageSuccess: 'メッセージを取り消しました',
  recallMessageFailed: 'メッセージの取り消しに失敗しました',
  recalledMessageLabel: '取り消し済み',
  recalledMessagePreview: '取り消し済み',
  notifyLineFailed:
    'LINE通知の送信に失敗しました。相手に新着通知が届いていない可能性があります',
} as const;

export const messageAssetStrings = {
  loadFailed:
    'メッセージ素材の取得に失敗しました。通信状況を確認して再読み込みしてください。',
  retry: '再読み込み',
  retrying: '読み込み中...',
} as const;

export const inquiryChatStrings = {
  contactListTitle: 'お問い合わせ',
  adminBadge: '運営',
  standardBadge: '標準',
  selectContact: '相手を選択して会話を開始してください',
  creatingChannel: 'チャットを準備中...',
} as const;

export const aiKnowledgeStrings = {
  title: 'AIナレッジ管理',
  description:
    'Dify.ai に連携したナレッジベースのドキュメントを管理します。お問い合わせチャットのAI回答候補生成に使用されます。',
  documentName: 'ドキュメント名',
  documentContent: 'テキスト内容',
  addDocument: 'ナレッジを追加',
  editDocument: 'ナレッジを編集',
  updateDocument: '更新',
  cancelEdit: 'キャンセル',
  selectDocumentHint: '一覧の項目をクリックして編集できます',
  deleteConfirm: 'このドキュメントを削除しますか？',
  emptyDocuments: 'ナレッジドキュメントがありません',
  addSuccess: 'ナレッジを追加しました',
  updateSuccess: 'ナレッジを更新しました',
  deleteSuccess: 'ナレッジを削除しました',
  delete: '削除',
  indexingStatus: 'インデックス状態',
  listTitle: 'ナレッジ一覧',
  loading: '読み込み中...',
  table: {
    actions: '操作',
    name: 'ドキュメント名',
    createdAt: '作成日時',
    indexingStatus: 'インデックス状態',
  },
} as const;

export const sendAllMessageStrings = {
  numberOfDeliveriesMessage: '配信数：${count}人',
  noDeliverableUsers: '配信できるユーザーがいません',
  deliveryCountLoadFailed:
    '配信対象数の取得に失敗しました。再読み込みしてから送信してください。',
  deliveryCountRetry: '再読み込み',
  sendAll: '一斉送信',
  sendFailed: '一斉送信に失敗しました。内容を確認してください。',
  sendSourceAlreadyUsed:
    '前回の送信IDは既に使用されています。今回の内容はまだ送信されていません。内容を確認のうえ、もう一度送信してください。',
  sendToAllCustomer: 'お客さん全員へ一斉送信',
  // 下書き一覧・配信予約一覧の双方から一斉送信画面へ戻るための共通文言
  backToSendAll: '一斉送信へ戻る',
  schedule: {
    submit: '予約を保存',
    confirm: '予約する',
    titleAll: 'お客さん全員への配信を予約しますか？',
    titleFiltered: '選択したタグの友だちへの配信を予約しますか？',
    titleUntagged: 'タグなしの友だちへの配信を予約しますか？',
    message:
      '${datetime} に配信します。この時刻まで送信されず、配信予約一覧から取り消し・変更できます。',
  },
  titleSendCustomer: 'お客さん全員へ一斉送信しますか？',
  contentSendCustomer: 'お客さん全員へ一斉送信します。宜しいでしょうか。',
  titleSendFiltered: '選択したタグの友だちへ一斉送信しますか？',
  contentSendFiltered:
    '選択したいずれかのタグを持つ友だちへ一斉送信します。宜しいでしょうか。',
  titleSendUntagged: 'タグなしの友だちへ一斉送信しますか？',
  contentSendUntagged:
    'タグが1つも付いていない友だちへ一斉送信します。宜しいでしょうか。',
  sendToAllTecoGirl: 'カノジョ全員へ一斉送信',
  titleSendTecoGirl: 'カノジョ全員へ一斉送信しますか？',
  contentSendTecoGirl: 'カノジョ全員へ一斉送信します。宜しいでしょうか。',
  send: '送信する',
  saveDraft: '下書き保存',
  testSend: {
    button: 'テスト配信',
    title: 'テストユーザーへテスト配信しますか？',
    content: 'テストユーザー${count}人へ配信します。宜しいでしょうか。',
    noTarget: 'テスト配信できるテストユーザーがいません',
    countLoadFailed: 'テスト配信対象数の取得に失敗しました。',
    success: 'テスト配信しました。',
  },
  recipient: {
    label: '送信対象',
    all: '全員',
    filter: 'タグで絞り込み',
    untagged: 'タグなし',
    tagHint: '選択したいずれかのタグを持つ友だちに送信します。',
    untaggedHint: 'タグが1つも付いていない友だちに送信します。',
    tagEmpty: 'タグがありません。タグ管理から作成できます。',
    tagLoading: 'タグを読み込み中...',
    tagRecipientUnavailable:
      'タグ管理機能が無効のため「${recipient}」では送信できません。送信対象を選び直してください。',
  },
  title: 'タイトル',
  news: '本文',
  content: 'コンテンツ',
  preview: 'プレビュー',
  showPreviewMessage: 'プレビューが表示されます',
  addContent: '+追加',
  emoji: '絵文字',
  nameInsertion: {
    button: '名前を挿入',
    hint: '{{name}} で友だちの名前を差し込めます。',
    namePriority: '管理者が設定したLINE名、LINEの表示名、共通の名前の順に使います。設定したLINE名は相手に送信されます。',
    lengthHint: '長い名前は、送信時に本文がLINEの5,000文字上限に収まるよう短縮します。名前を入れる余裕がない場合は、名前を省略します。',
  },
  uploadPhoto: '写真をアップロード',
  uploadVideo: '動画をアップロード',
  uploadPdf: 'PDFをアップロード',
  pdfLabel: 'PDF',
  fileFormats: 'ファイル形式',
  fileSizeUpTo: 'ファイルサイズは最大 ${size}MB までです。',
  icons: {
    iconNames: {
      text: 'T',
      image: 'image',
      video: 'video',
      file: 'PDF',
      imageUrl: 'imageUrl',
      videoUrl: 'videoUrl',
    },
    iconLabels: {
      text: 'テキスト入力',
      image: '画像挿入',
      video: '動画挿入',
      file: 'PDF挿入',
      imageUrl: '画像URL挿入',
      videoUrl: '動画URL挿入',
    },
  },
  actionLabelDefault: 'もっと見る',
  contentTypes: {
    textInput: 'テキスト入力',
    imageInsert: '画像挿入',
    videoInsert: '動画挿入',
    imageUrlInsert: '画像URL挿入',
    videoUrlInsert: '動画URL挿入',
  },
  actions: {
    moveUp: '上に移動',
    moveDown: '下に移動',
    delete: '削除',
  },
  placeholders: {
    textInput: 'テキストを入力...',
    actionUrlInput: 'アクションURLを入力...',
    imageUrlInput: '画像URLを入力...',
    videoUrlInput: '動画URLを入力...',
    selectAsset: 'メッセージ素材を選択',
  },
  errors: {
    invalidUrl: '有効なURLを入力してください',
  },
  assetPreview: {
    selectAsset: 'メッセージ素材を選択してください',
    noPreviewImage: 'プレビュー画像がありません',
    noCardsConfigured: 'カードが設定されていません',
  },
  assetSelect: {
    registerFromSettingsSuffix: 'を設定画面から登録してください',
  },
  contentHeader: {
    moveUp: '上に移動',
    moveDown: '下に移動',
    delete: '削除',
    message: {
      image: '「画像」',
      inputPlaceholder: 'メッセージを入力...',
      isTyping: 'が入力しています',
      startMessage: '会話を始めます。',
    },
    header: {
      ...headerStrings,
    },
    dashboard: {
      ...dashboardStrings,
    },
    sidebar: {
      ...sidebarStrings.navLabels,
      chatMale: 'チャット',
    },
    error: {
      limitSize: '写真は$sizeを超えてはなりません',
      limitFile: 'ファイル数は$number個までです',
    },
    sendTime: {
      label: '送信日時',
      immediate: '即時',
      datePlaceholder: '日付を選択',
    },
  },
  drafts: {
    listTitle: '一斉送信下書き一覧',
    empty: '下書きがありません',
    loading: '読み込み中...',
    table: {
      actions: '操作',
      name: '名前',
      preview: 'プレビュー',
      sectionCount: 'セクション数',
      createdAt: '作成日時',
      updatedAt: '更新日時',
    },
    actions: {
      preview: 'プレビュー',
      apply: '適用',
      delete: '削除',
    },
    deleteConfirm: {
      title: '下書きを削除',
      message: 'この下書きを削除してもよろしいですか？',
    },
    messages: {
      loaded: '下書きを読み込みました',
      saved: '下書きを保存しました',
      updated: '下書きを更新しました',
      deleted: '下書きを削除しました',
      notFound: '下書きが見つかりません',
      noId: '下書きIDが見つかりません',
      invalidSendOption:
        '下書きの送信対象を読み込めませんでした。送信対象を設定し直してください。',
    },
    saveModal: {
      title: '下書きを保存',
      message: 'この内容で下書きを保存しますか？',
      nameLabel: '名前',
      namePlaceholder: '下書きの名前を入力...',
      cancel: 'キャンセル',
      confirm: '保存',
    },
    preview: {
      empty: '空の下書き',
      image: '画像',
      video: '動画',
      file: 'PDF',
      survey: 'アンケート',
      richMessage: 'リッチメッセージ',
      cardTypeMessage: 'カードタイプメッセージ',
      defaultName: '下書き',
    },
  },
  reservations: {
    listTitle: '配信予約一覧',
    empty: '配信予約がありません',
    loading: '読み込み中...',
    table: {
      edit: '編集',
      actions: '操作',
      scheduledDateTime: '配信予定日時',
      recipient: '配信対象',
      preview: 'プレビュー',
      sectionCount: 'セクション数',
      createdBy: '作成者',
      createdAt: '作成日時',
    },
    actions: {
      preview: 'プレビュー',
      edit: '編集',
      cancel: '取り消し',
    },
    truncatedNotice:
      '配信予約が多いため、一部が一覧に表示されていません。予約を取り消して件数を減らしてください。',
    notEditableHint:
      'この配信予約は一度配信を試みているため編集できません。取り消してから作り直してください。',
    recipients: {
      all: '全員',
      filter: 'タグ指定',
      untagged: 'タグなし',
      unknown: '不明',
    },
    cancelConfirm: {
      title: '配信予約を取り消す',
      message:
        'この配信予約を取り消しますか？取り消すと、この内容は配信されません。',
    },
    updateConfirm: {
      title: '配信予約を更新',
      message: 'この内容で配信予約を更新しますか？',
    },
    editing: {
      banner: '配信予約を編集しています。更新するまで元の予約内容は変わりません。',
      submit: '予約を更新',
      cancelEdit: '編集をやめる',
    },
    messages: {
      loaded: '配信予約を読み込みました',
      updated: '配信予約を更新しました',
      canceled: '配信予約を取り消しました',
      invalidSendOption:
        '配信予約の配信対象を読み込めませんでした。配信対象を設定し直してください。',
    },
    scheduledDateTimeUnknown: '不明',
  },
} as const;

export const surveySelectorStrings = {
  label: 'アンケート',
  placeholder: '選択してください',
  loadFailed:
    'アンケートの取得に失敗しました。通信状況を確認して再読み込みしてください。',
  retry: '再読み込み',
  retrying: '読み込み中...',
  emptyHint: '公開中のフォーム回答アンケートを選択してください。',
  guideLabel: '案内文（任意）',
  guidePlaceholder: 'アンケートにご回答ください。',
  inviteImageLabel: '案内画像（任意）',
  inviteImageAspectLabel: '画像の比率',
} as const;

export const autoReplySettingsQueryStrings = {
  loadFailed:
    '自動応答設定の取得に失敗しました。通信状況を確認して再読み込みしてください。',
  retry: '再読み込み',
  retrying: '読み込み中...',
} as const;

export const oaCreationStrings = {
  title: '公式LINE作成',
  description:
    'Chrome 拡張機能と連携してLINE公式アカウントを一括作成します。作成完了後も拡張機能側で処理が継続されるため、別タブで結果を確認できます。',
  actions: {
    create: 'LINE公式アカウント作成',
    submitting: '登録中...',
    reload: '再読み込み',
    reloading: '読み込み中...',
  },
  messages: {
    createSuccess: 'ジョブを登録しました。拡張機能で処理を開始してください。',
  },
  confirm: {
    title: 'LINE公式アカウント作成を開始しますか？',
    messageTemplate:
      '「$accountName」を $quantity 件作成するジョブを登録します。よろしいですか？',
    cancel: 'キャンセル',
    confirm: '実行する',
  },
  form: {
    title: '作成情報の入力',
    description: '作成する公式LINEアカウントの情報を入力してください。',
    fields: {
      businessAccount: {
        label: 'LINEビジネスアカウント',
        placeholder: '例: 株式会社サンプル',
      },
      accountName: {
        label: 'アカウント名',
        placeholder: '例: BROWN Coffee',
      },
      quantity: {
        label: '作成件数',
        placeholder: '例: 10',
        hint: '1件以上で指定してください。',
      },
      email: {
        label: 'ビジネスアカウントのメールアドレス',
        placeholder: '例: business@example.com',
        hint: '履歴に保存されます。LINE Official Account Manager のログインメールを入力してください。',
      },
      icon: {
        label: 'アイコン画像',
        select: 'ファイルを選択',
        change: '変更',
        remove: '削除',
        accepted: 'JPG / JPEG / PNG ・ 3MB以下 ・ 640×640px（推奨サイズ）',
        dimensionWarning:
          '推奨サイズは 640×640 ピクセルです（$width×$height）。そのまま登録できます。',
      },
      creator: {
        label: '作成者',
      },
    },
  },
  errors: {
    required: '必須項目を入力してください。',
    quantityInvalid: '作成件数は1以上の数値で指定してください。',
    emailInvalid: 'メールアドレスの形式が不正です。',
    iconUploadFailed: 'アイコン画像のアップロードに失敗しました。',
    iconTooLarge: '画像は 3MB 以下のものを指定してください。',
    iconTypeInvalid: 'JPG / JPEG / PNG 形式の画像を指定してください。',
    iconInvalidImage: '画像ファイルを読み込めませんでした。',
    submitFailed: 'ジョブの登録に失敗しました。',
    unauthorized: '認証情報が取得できませんでした。再ログインしてください。',
    loadJobsFailed: 'ジョブ一覧の取得に失敗しました。',
  },
  table: {
    title: '作成履歴',
    headers: {
      createdAt: '実行日時',
      accountName: 'アカウント名',
      icon: 'アイコン',
      quantity: '作成件数',
      progress: '進捗',
      email: 'ビジネスアカウント',
      status: 'ステータス',
    },
    progressTemplate: '$success / $total',
    progressWithFailedTemplate: '$success 成功 / $failed 失敗 / $total',
    states: {
      empty: 'まだ作成履歴がありません。',
      noIcon: '-',
    },
    pauseReasonLabel: '中断理由',
  },
  status: {
    PENDING: '待機中',
    RUNNING: '処理中',
    PAUSED: '一時停止',
    COMPLETED: '完了',
    FAILED: '失敗',
    ROLLED_BACK: 'ロールバック済み',
    ROLLBACK_TODO: 'ロールバック未',
    CANCELLED: 'キャンセル',
  },
  pagination: {
    previous: '前へ',
    next: '次へ',
    page: 'ページ',
    empty: '0 / 0',
  },
} as const;

export const messageSettingsStrings = {
  title: 'メッセージ設定',
  description: '自動送信されるメッセージを編集できます。',
  sendToChatLabel: '個別チャットにも送信する',
  sendToChatHint:
    'ONにすると、友だち追加時にこの挨拶メッセージを個別チャットにも自動で送信します。',
  // backend の messageTemplateMessages.fileSectionGreetingOnly と文言を揃える
  fileSectionGreetingOnly:
    'PDFは、挨拶メッセージを個別チャットにも送信する設定のときだけ利用できます。',
  sendToChatCardDisabledHint:
    'カードタイプメッセージを含む場合、個別チャットには送信されません。',
  tabs: {
    GREETING: '挨拶メッセージ',
    MIGRATION: '移行メッセージ',
    NOTIFICATION: '通知メッセージ',
  },
  descriptions: {
    GREETING: 'LINE友達追加時に自動送信されるメッセージです。',
    MIGRATION: '移行時に送信されるメッセージです。',
    NOTIFICATION: 'チャットメッセージ着信時にLINEへ送信される通知です。',
  },
  buttonLabels: {
    GREETING: '確認する',
    MIGRATION: '確認する',
    NOTIFICATION: 'チャットを確認',
  },
  buttonLabelField: '導線ボタンラベル',
  buttonLabelHint:
    'テキスト末尾に表示されるチャットリンクボタンの文言です（最大20文字）。',
  buttonLabelRequired: '導線ボタンラベルを入力してください。',
  buttonLabelTooLong: '導線ボタンラベルは20文字以内にしてください。',
  defaults: {
    GREETING:
      '「確認する」ボタンからお問い合わせが可能です。\nどうぞお気軽にご連絡ください。',
    MIGRATION:
      '「確認する」ボタンからお問い合わせが可能です。\nどうぞお気軽にご連絡ください。',
    NOTIFICATION: '運営からメッセージが届きました',
  },
  planDefaults: {
    GREETING:
      'お友だち登録ありがとうございます。引き続きよろしくお願いいたします。',
    MIGRATION:
      'お友だち登録ありがとうございます。引き続きよろしくお願いいたします。',
    NOTIFICATION: '運営からメッセージが届きました',
  },
  save: '保存',
  saveSuccess: 'メッセージ設定を保存しました',
  saveFailed: 'メッセージ設定の保存に失敗しました',
  loadFailed: 'メッセージ設定の取得に失敗しました',
  textSectionRequired:
    'テキストセクションが必要です。導線ボタンはテキストに付与されます。',
  greetingContentRequired:
    'テキスト、カードタイプメッセージ、またはアンケートを設定してください。',
  addContent: 'セクションを追加',
  preview: 'プレビュー',
} as const;

export const autoReplyMessageStrings = {
  title: '自動応答メッセージ',
  description: '組織配下のLINE公式アカウントへ共通の自動応答を設定します。',
  tabs: {
    uniform: '一律応答機能',
    keyword: 'キーワード応答機能',
    time: '応答時間設定',
  },
  save: '保存',
  addMessage: 'メッセージを追加',
  addKeywordRule: 'キーワード応答を追加',
  enabled: '有効',
  disabled: '無効',
  uniformDescription:
    'キーワードに完全一致しない場合の基本応答です。営業時間外は応答時間設定に従います。',
  keywordDescription:
    '登録キーワードと完全一致した場合に優先して送信し、一律応答は同時送信しません。営業時間外は応答時間設定に従います。',
  timeDescription:
    'ON時は時間帯設定を適用します。OFF時はキーワード一致を優先し、非一致時だけ一律応答を送信します。',
  keywordPlaceholder: 'キーワードを入力してEnter',
  ruleNamePlaceholder: '応答名',
  chatLink: {
    label: 'チャットへのリンクを付ける',
    // backend の AUTO_REPLY_CHAT_LINK_TEXT / AUTO_REPLY_CHAT_LINK_BUTTON と同じ文言にする
    previewText: 'チャットでご相談いただけます',
    previewButton: 'チャットを開く',
    uniformDescription:
      '応答の最後に、その方専用のチャット画面を開くボタンを追加します。',
    keywordDescription:
      '応答の最後に、その方専用のチャット画面を開くボタンを追加します。ONにしたキーワード応答は、応答時間設定にかかわらず常に返信します。同じキーワードで他のキーワード応答も登録している場合、この応答だけが送信されます。リッチメニューに同じ文言のテキスト送信を設定すると、タップだけでチャットへ案内できます。',
    lightPlanNote:
      'ご利用中のプランではチャット機能を使えないため設定できません。',
    textFieldLabel: 'リンクに添える文章',
    buttonFieldLabel: 'ボタンの文言',
    blankNote: '空欄のままにすると、上の例の文言で送ります。',
  },
  businessHourMode: {
    KEYWORD_ONLY: 'キーワード応答のみ（非一致時は無応答）',
    UNIFORM_AND_KEYWORD: 'キーワード優先（非一致時は一律応答）',
  },
  outsideHourMode: {
    UNIFORM_ONLY: '一律応答のみ',
    NO_REPLY: '無応答',
  },
  businessHours: {
    closedDay: '定休日',
    timeRangeSeparator: '〜',
    duringHoursLabel: '営業時間内の挙動',
    outsideHoursLabel: '営業時間外の挙動',
  },
  weekdays: {
    MONDAY: '月',
    TUESDAY: '火',
    WEDNESDAY: '水',
    THURSDAY: '木',
    FRIDAY: '金',
    SATURDAY: '土',
    SUNDAY: '日',
  },
  contentTypes: {
    text: 'テキスト',
    image: '画像',
    video: '動画',
    richMessage: 'リッチメッセージ',
    cardTypeMessage: 'カードタイプメッセージ',
  },
  assets: {
    richTitle: 'リッチメッセージ',
    cardTitle: 'カードタイプメッセージ',
    name: '名称',
    altText: '代替テキスト',
    imageUrl: '画像URL',
    title: 'タイトル',
    text: '本文',
    actionUrl: 'アクションURL',
    actionLabel: 'アクションラベル',
    addCard: 'カードを追加',
    addAction: 'アクションを追加',
    saveSuccess: 'メッセージ素材を保存しました',
    deleteSuccess: 'メッセージ素材を削除しました',
    deleteFailed: '削除に失敗しました',
  },
  messages: {
    saveSuccess: '自動応答設定を保存しました',
    keywordSaveSuccess: 'キーワード応答を保存しました',
    keywordDeleteSuccess: 'キーワード応答を削除しました',
    saveFailed: '保存に失敗しました',
    deleteFailed: '削除に失敗しました',
  },
} as const;

// Compatibility export: strings object that combines all string exports
export const strings = {
  common: {
    somethingWentWrong: '何か問題が発生しました。',
    receivedMessage: 'メッセージが届きました！',
    noData: 'データなし。',
    search: '検索',
    draft: 'ドラフト: ',
    MrMiss: 'さん',
    success: '成功しました',
    cancel: 'キャンセル',
    send: '送信',
    pagination: {
      previous: '← 前へ',
      next: '次へ →',
      showing: '$total件中 $start - $end件を表示',
    },
    table: {
      empty: 'データがありません',
      loading: '読み込み中...',
    },
  },
} as const;

export const adCodeStrings = {
  title: '広告コード',
  description:
    '広告ごとに友だち追加URLを発行し、どの広告から友だちが増えたかを確認します',
  create: '新規作成',
  createTitle: '広告コードを作成',
  greetingMeasurementRequirement:
    'あいさつメッセージに画像または動画がない場合、流入元を確定して計測できません。広告コードを利用する前に、あいさつメッセージへ画像または動画を設定してください。',
  editTitle: '広告コードを編集',
  breadcrumb: '広告コード',
  empty: {
    title: '広告コードはまだありません',
    description:
      '広告ごとにURLを発行すると、どの広告から友だち追加されたかが分かり、流入元ごとにタグを付けられます。',
    archivedHint: 'アーカイブ済みに $count 件一致します。',
    showAll: 'すべての状態を表示',
  },
  filters: {
    period: '期間',
    status: '状態',
    medium: '媒体',
    search: '管理名・コードで検索',
    excludeBlocked24h: '24時間以内のブロックを除外',
    all: 'すべて',
  },
  metrics: {
    adCodeCount: '広告コード',
    click: 'クリック',
    registration: '登録',
    registrationConfirmed: '登録（確定）',
    registrationEstimated: '登録（推定）',
    registrationRate: '登録率',
    blocked24h: '24hブロック',
    blocked: '総ブロック',
    estimatedPrefix: '推定 +',
  },
  columns: {
    name: '管理名',
    code: 'コード',
    status: '状態',
    actions: '操作',
    lineName: 'LINE名',
    receivedAccount: '受信アカウント',
    attributedAt: '追加日時',
    confidence: '確度',
    kind: '区分',
    state: '状態',
    tags: 'タグ',
  },
  form: {
    name: '管理名',
    nameHelp: '50文字まで。組織内で重複できません',
    medium: '媒体',
    memo: 'メモ',
    customMediumOption: '別の媒体名を入力…',
    customMedium: '媒体名（必須）',
    customMediumPlaceholder: '例: Instagram、店頭チラシ',
    customMediumHelp: '50文字まで。保存すると次回から候補に表示されます',
    mediumHelp: 'URLを掲載する媒体を選んでください。選択肢にない名前も入力できます',
    memoPlaceholder: 'キャンペーンの期間や担当者など',
    tags: '友だち追加時に付与するタグ',
    tagsHelp:
      'このタグを条件にしたステップ配信・あいさつの出し分けが使えます',
    applyTagsOnEstimated: '推定の流入元にもタグを付ける',
    applyTagsOnEstimatedHelp:
      '友だち追加の時刻から推定した流入元にもタグを付けます（誤って付く可能性があります）',
    submitCreate: '作成する',
    submitUpdate: '保存する',
    cancel: 'キャンセル',
  },
  detail: {
    urlLabel: '発行URL（広告・投稿・QRに使います）',
    copyUrl: 'URLをコピー',
    copySuccess: 'コピーしました',
    copyError: 'コピーに失敗しました',
    saveQr: 'QRを保存（PNG）',
    urlUnavailable:
      '公開URLが未設定のため発行URLを表示できません。管理者にお問い合わせください。',
    attributions: 'この広告から追加した友だち',
    attributionsEmpty: 'この広告から追加した友だちはまだいません',
    edit: '編集',
    archive: 'アーカイブ',
    unarchive: 'アーカイブから戻す',
  },
  confidence: {
    HIGH: '確定',
    LOW: '推定',
  },
  method: {
    IP: '端末一致',
    TIME: '時刻一致',
    LOGIN: 'LINEログイン',
  },
  kind: {
    new: '新規',
    refollow: '再追加',
  },
  friendState: {
    active: '友だち',
    blocked: 'ブロック',
    blocked24h: 'ブロック（24h内）',
  },
  status: {
    ACTIVE: '有効',
    ARCHIVED: 'アーカイブ',
  },
  medium: {
    SEARCH_AD: '検索広告',
    SNS_AD: 'SNS広告',
    SNS_POST: 'SNS投稿',
    VIDEO: '動画',
    LANDING_PAGE: 'LP',
    PRINT: '印刷物',
    EMAIL: 'メール',
    OTHER: 'その他',
  },
  greetingWarning:
    '流入元を確定するには、あいさつメッセージに画像か動画が必要です。無い場合は友だち追加の時刻からの推定になります。',
  noActiveChannel:
    '友だち追加に払い出せるLINEチャンネルがありません（稼働中・Webhook検証済み・ベーシックIDありのアカウントが必要です）。このままでは発行URLとQRを開いても友だち追加できず、受付停止中の案内になります。LINE管理で連携状況を確認してください。',
  confirm: {
    archiveTitle: '広告コードをアーカイブしますか？',
    archiveMessage:
      'アーカイブ後もURLは有効で友だち追加は妨げませんが、計測は止まります。これまでの記録は残ります。',
    archiveConfirm: 'アーカイブする',
  },
  messages: {
    created: '広告コードを作成しました',
    updated: '広告コードを更新しました',
    archived: '広告コードをアーカイブしました',
    unarchived: 'アーカイブを解除しました',
    urlCopied: 'URLをコピーしました',
  },
  errors: {
    loadFailed: '広告コードの取得に失敗しました。',
    loadMediaFailed: '保存済み媒体の取得に失敗しました。再試行してください。',
    loadAttributionsFailed: '友だち一覧の取得に失敗しました。',
    saveFailed: '広告コードの保存に失敗しました。',
    archiveFailed: 'アーカイブに失敗しました。',
    nameRequired: '管理名を入力してください。',
    mediumRequired: '媒体名を入力してください。',
    mediumTooLong: '媒体名は50文字以内で入力してください。',
  },
} as const
